import { useCallback, useState } from 'react';

export interface UseModalControllerPayload {
    isOpen: boolean;
    onOpen: VoidFunction;
    onClose: VoidFunction;
    dismissOnOutsideClick?: boolean;
    closable?: boolean;
}

interface useModalControllerProps {
    initialOpen?: boolean;
    dismissOnOutsideClick?: boolean;
    closable?: boolean;
}

export function useModalController(props: useModalControllerProps = {}): UseModalControllerPayload {
    const { initialOpen = false, dismissOnOutsideClick = true, closable = true } = props;
    const [isOpen, setIsOpen] = useState<boolean>(initialOpen);
    const onOpen = useCallback(() => setIsOpen(true), [setIsOpen]);
    const onClose = useCallback(() => setIsOpen(false), [setIsOpen]);

    return { isOpen, onOpen, onClose, dismissOnOutsideClick, closable };
}
